// extracted by mini-css-extract-plugin
module.exports = {"jobCard":"JobImport_jobCard__2Gn3Y","content":"JobImport_content__1aw_u","title":"JobImport_title__1hFoH","state":"JobImport_state__2SX6k","progress":"JobImport_progress__2F8i-"};